import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'bytes' })
export class BytesPipe implements PipeTransform {

    transform(value: any, decimales: number) {
        if (value) {
            const c = 1024,
                d = decimales || 2,
                e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
                f = Math.floor(Math.log(value) / Math.log(c));

            return parseFloat((value / Math.pow(c, f)).toFixed(d)) + " " + e[f];
        }

        return "0 Bytes";
    }

}